import React from 'react'
import { Link } from 'react-router-dom'
import Buscador from '../../../../Reutilizables/buscador/Buscador'
import "../../../../../styles/servicios/tasas/menuTasas.css"

function MenuTasas() {
  return (
    <div className="navbar navbar-servi">

        <div className='first-link'>
          <Link to="/servicios" className='nav-link'>Servicios</Link>
        </div>

        <div className='first-link'>
          <Link to="/servicios-tasas-derecho-trancito" className='nav-link'>Derecho de tráncito</Link>
        </div>

        <div className='first-link'>
          <Link to="/servicios-tasas-peaje-estacionamiento" className='nav-link'>Peaje de estacionamiento</Link>
        </div>

        <div className='first-link'>
          <Link to="/servicios-tasas-peaje-turistico" className='nav-link'>Peaje turistico</Link>
        </div>

        <div className='first-link'>
          <Link to="/servicios-tasas-retributibas" className='nav-link'>Retributivas</Link>
        </div>

        <div className='first-link'>
          <Link to="/servicios-tasas-utilizacion-agua" className='nav-link'>Utilizacion del agua</Link>
        </div>

        <div className='search search-servi search-servi-tasas'>
          <Buscador />
        </div>
        
      </div>
  )
}

export default MenuTasas